/**
 * EWS Task Processor
 * Handles tasks specific to the EWS (Event Writer Service) worker
 */

import { BaseTaskProcessor, TaskHandlerRegistry } from '../shared/task_handler';
import { customPixelHandler, wtagHandler } from './task_handlers/index';

/**
 * EWS task processor
 * Responsible for handling all tasks for the EWS worker
 */
export class EWSTaskProcessor extends BaseTaskProcessor {
  /**
   * Worker name for logging
   */
  protected workerName = 'EWS';

  /**
   * Constructor
   */
  constructor() {
    // Define task handlers specific to EWS worker
    const ewsTaskHandlers: TaskHandlerRegistry = {
      SEND_CUSTOM_PIXEL_EVENT: customPixelHandler,
      SEND_MABLE_EVENT: customPixelHandler,
      SEND_WTAG_EVENT: wtagHandler,
    };

    // Initialize with EWS specific handlers
    super(ewsTaskHandlers);
  }
}
